<template>
	<div class="pin-button-container flex-centerize">
		<AppTooltip :position="tooltipPosition" :text="tooltipText">
			<div class="flex-centerize width-100 height-100">
				<AppIcon :name="`${isPinned ? 'pinned' : 'pin'}-projects-menu`" />
			</div>
		</AppTooltip>
	</div>
</template>

<script>
export default {
	name: 'PinButton',
	props: {
		isPinned: { type: Boolean, default: false },
		tooltipText: { type: String, default: 'Pin' },
		tooltipPosition: { type: String, default: 'bottom' },
	},
};
</script>

<style scoped lang="scss">
.pin-button-container {
	cursor: pointer;
	border-radius: 50%;
	background: var(--white);
	border: 1px solid #e7e7ed;
	width: $pin-projects-button-size;
	height: $pin-projects-button-size;
	&:hover {
		background: #efeff3;
	}
}
</style>
